import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateDefaultYear, getBookMaster } from 'app/contexts/reducers/bookMaster/bookMasterSlice';
import { getFinancialYear } from 'app/utils/financialYear';
import { Alert, Box, Typography } from '@mui/material';

const FinancialYearInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const { bookYear, bookMasterData, isBookMasterSuccess } = useSelector((state) => state.bookMaster);
  const initialized = useRef(false);
  const [yearMissing, setYearMissing] = useState(false);

  useEffect(() => {
    dispatch(getBookMaster());
  }, [dispatch]);

  useEffect(() => {
    if (!initialized.current) {
      const calculatedYear = getFinancialYear(new Date());
      
      // If the stored year is older than the current financial year, update it.
      if (!bookYear || bookYear < calculatedYear) {
        dispatch(updateDefaultYear(calculatedYear));
      }
      initialized.current = true;
    }
  }, [dispatch, bookYear]);

  useEffect(() => {
    if (isBookMasterSuccess && bookMasterData?.data?.data) {
      const years = bookMasterData.data.data;
      const yearExists = years.some(b => b.name === bookYear);
      if (!yearExists) {
        setYearMissing(true);
      } else {
        setYearMissing(false);
      }
    }
  }, [isBookMasterSuccess, bookMasterData, bookYear]);

  return (
    <>
      {yearMissing && (
        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999 }}>
          <Alert severity="error" variant="filled" sx={{ borderRadius: 0 }}>
            <Typography variant="body1">
              <strong>Attention:</strong> The financial year <strong>{bookYear}-{bookYear + 1}</strong> has not been configured in the Book Master. 
              Please ask an administrator to create it to prevent errors during transaction creation.
            </Typography>
          </Alert>
        </Box>
      )}
      <Box sx={{ pt: yearMissing ? '64px' : 0 }}>
        {children}
      </Box>
    </>
  );
};

export default FinancialYearInitializer;
